module.exports = __webpack_public_path__ + "img/Work From Home Neck Stretch.65e94fb0.png";